import React, { useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Box, Tab, Tabs } from "@mui/material";
import { LGTabPanel } from "../../molecules/LGTabPanel";
import { useCompany } from "../../contexts/CompanyContext";
import ScheduledPaymentCrud from "../../organisms/ScheduledPayments/ScheduledPaymentCrud";
import PaymentTxCrud from "../../organisms/PaymentTx/PaymentTxCrud";

export default function PaymentsV2Screen() {
  const [activeTab, setActiveTab] = useState(0);
  const { selectedCompany } = useCompany();

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <DashboardLayout>
      <Box
        sx={{
          backgroundColor: "white",
          borderBottom: 1,
          borderColor: "divider",
          position: "fixed",
          zIndex: 99,
          width: "100%",
        }}
      >
        <Tabs value={activeTab} onChange={handleChange}>
          <Tab label="Programación de pagos" />
          <Tab label="Transacciones de pago" />
        </Tabs>
      </Box>

      <Box p={4}>
        <LGTabPanel value={activeTab} index={0}>
          <ScheduledPaymentCrud props={{ companyId: selectedCompany.id }} />
        </LGTabPanel>
        <LGTabPanel value={activeTab} index={1}>
          <PaymentTxCrud props={{ companyId: selectedCompany.id }} />
        </LGTabPanel>
      </Box>
    </DashboardLayout>
  );
}
